import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { myInfoSelector } from '../../recoil/selectors';
import { useRecoilValueLoadable } from 'recoil';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { BlockUI } from 'primereact/blockui';
import Claim from '../../services/ClaimService';
import { isInsuranceDemoAccount } from '../../utils/safeInsuranceDemoUtil';

const Dashboard = () => {
  const IntFormatter = new Intl.NumberFormat('ko-KR', { style: 'decimal' });
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    claimReceiptCount: 0,
    claimWaitingCount: 0,
    claimCompleteCount: 0,
    claimRejectCount: 0,
    claimCarInCount: 0,
    claimRepairCount: 0,
    claimUnderRepairCount: 0,
    claimRepairCompleteCount: 0,
    claimNotRepairedCount: 0,
    claimExclusionCount: 0,
    claimMonthCount: 0,
    claimInAgreementCount: 0, // 외판_사고접수
    claimAgreementCount: 0, // 외판_면책종결
    claimPaymentTerminationCount: 0, // 외판 지급종결
  });

  const history = useHistory();
  const myInfoLoadable = useRecoilValueLoadable(myInfoSelector);
  const partner = myInfoLoadable?.contents?.roleCode === 'D_ADM';
  const isInsuranceDemo = isInsuranceDemoAccount(
    myInfoLoadable?.contents?.loginId
  );

  const getData = async () => {
    setLoading(true);
    try {
      const data = await Claim.homeInfo();
      if (data) {
        setData(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (partner) {
      history.push('/compensation/accident/list');
    } else {
      getData();
    }
  }, [partner, history]);

  const today = new Date();

  const CommonPanel = ({ title, value, type }) => {
    return (
      <div className="md:col-4 col-6">
        <Panel header={title}>
          <div className="text-lg">
            {IntFormatter.format(value) + `${!type ? ' 건' : ' %'}`}
          </div>
        </Panel>
      </div>
    );
  };

  return (
    <BlockUI
      blocked={loading}
      template={
        <i className="pi pi-spin pi-spinner text-white-alpha-90 font-bold text-6xl" />
      }
    >
    <Card title="사고 관리" className="dashboard-h p-2">
      <div className="pr-3 pb-2 flex justify-content-end align-items-center gap-2">
        <i className="pi pi-database" />
        {today.getMonth() + 1 + ' 월'}
      </div>
      <div className="grid text-center">
        {!isInsuranceDemo && (
          <>
            <CommonPanel title="고객 접수중" value={data.claimReceiptCount} />
            <CommonPanel
              title="서류접수(고객/매매상사) 대기중"
              value={data.claimWaitingCount}
            />
            <CommonPanel
              title="서류접수(고객/매매상사) 완료"
              value={data.claimCompleteCount}
            />
            <CommonPanel title="거절안내 완료" value={data.claimRejectCount} />
          </>
        )}
        <CommonPanel title="입고안내 완료" value={data.claimCarInCount} />
        <CommonPanel title="입고점검 완료" value={data.claimRepairCount} />
        <CommonPanel title="수리 진행중" value={data.claimUnderRepairCount} />
        <CommonPanel title="수리 완료" value={data.claimRepairCompleteCount} />
        <CommonPanel title="보류" value={data.claimNotRepairedCount} />
        <CommonPanel title="면책종결" value={data.claimExclusionCount} />
        <CommonPanel title="지급종결" value={data.claimMonthCount} />
        <CommonPanel title="외판_사고접수" value={data.claimInAgreementCount} />
        <CommonPanel title="외판_면책종결" value={data.claimAgreementCount} />
        <CommonPanel
          title="외판 지급종결"
          value={data.claimPaymentTerminationCount}
        />
      </div>
    </Card>
    </BlockUI>
  );
};

export default Dashboard;
